import { useEffect } from 'react';

import type { StepDetailProps } from '../types';
import { QuestionnaireAnswersView } from './QuestionnaireAnswersView';

/**
 * The module's read-only Detail for a Questionnaire step.
 *
 * A THIN WRAPPER around `QuestionnaireAnswersView`, which is also what the session view's
 * `StepAccordion` renders — so the answers are drawn by one component in both places. This file used
 * to hold its own full copy of that rendering; two renderers for one thing is how the label for a
 * date-range or a dropdown cascade ends up formatted differently depending on which screen you are on.
 */
export function QuestionnaireDetail({ session, step, onReadyChange }: StepDetailProps) {
  // Nothing here is editable, so there is no form to submit and nothing to wait for. Reported once so
  // the host panel does not sit disabled waiting on a step that will never become "ready".
  useEffect(() => {
    onReadyChange(true);
  }, [onReadyChange]);

  return (
    <QuestionnaireAnswersView sessionId={session.id} stepId={step.id} inputJson={step.inputJson} />
  );
}
